"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectItem } from "@/components/ui/simple-select";
import type { SimpleFieldConfig } from "../../../types/index";

interface TextFilterInputProps {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  currentFilter?: { type: string; value: any };
  addAdvancedFilter: (fieldId: string, filterType: string, value: any) => void;
}

export function TextFilterInput({
  fieldId,
  fieldConfig,
  currentFilter,
  addAdvancedFilter,
}: TextFilterInputProps) {
  return (
    <div className="space-y-2">
      <Select
        value={currentFilter?.type || "contains"}
        onValueChange={(type) => {
          if (type === "notNull") {
            addAdvancedFilter(fieldId, type, true);
          } else {
            addAdvancedFilter(fieldId, type, currentFilter?.value || "");
          }
        }}
        className="w-full"
      >
        <SelectItem value="contains">Contains (ilike)</SelectItem>
        <SelectItem value="exact">Exact Match (eq)</SelectItem>
        <SelectItem value="neq">Not Equal (neq)</SelectItem>
        <SelectItem value="startsWith">Starts With</SelectItem>
        <SelectItem value="endsWith">Ends With</SelectItem>
        <SelectItem value="notNull">Has Value (is NOT NULL)</SelectItem>
      </Select>
      {currentFilter?.type !== "notNull" && (
        <Input
          placeholder={
            fieldId === "tags"
              ? "Enter tags (comma-separated): vip, important, follow-up"
              : `Filter by ${fieldConfig.label}`
          }
          value={currentFilter?.value || ""}
          onChange={(e) =>
            addAdvancedFilter(fieldId, currentFilter?.type || "contains", e.target.value)
          }
          className="w-full"
        />
      )}
      {currentFilter?.type === "notNull" && (
        <div className="text-xs text-gray-500 bg-card-50 p-2 rounded border">
          Shows only records where {fieldConfig.label} has any value (not null, undefined, or empty)
        </div>
      )}
    </div>
  );
}
